/**
 * Filtros para productos de órdenes/pedidos
 * Permite filtrar por estado del producto
 */
import React, { useContext } from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    FormControl,
    Select,
    MenuItem
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import InventoryIcon from "@mui/icons-material/Inventory";
import { FieldLabel } from "../ui";
import ProductStates from "../../../../utils/ProductStates";
import { StateContext } from "../../../../components/context/StateProvider";

const FiltrosProductos = ({ productStates, filter }) => {
    const { state } = useContext(StateContext);

    if (!productStates) return null;

    // DECISION: el valor del Select se reconstruye desde el filtro aplicado en ListOrder,
    // que guarda (valor - 1) como estado del producto; ver ListOrder.filterList
    const valorSeleccionado = state.filters.length > 0
        ? parseInt(state.filters.find(item => item.field === 'state')?.value, 10) + 1
        : 3;

    const handleChange = (event) => {
        filter(event.target.value);
    };

    return (
        <Card
            sx={{
                mb: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                border: "1px solid #e9ecef",
                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    p: 2.5,
                    backgroundColor: "#f8f9fa",
                    borderBottom: "2px solid #e9ecef",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 36,
                        height: 36,
                        borderRadius: 1.5,
                        backgroundColor: "#fff",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.06)"
                    }}
                >
                    <FilterListIcon sx={{ fontSize: 20, color: "#cc071e" }} />
                </Box>
                <Box sx={{ flex: 1 }}>
                    <Typography
                        sx={{
                            fontSize: 11,
                            fontWeight: 600,
                            color: "#6c757d",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            mb: 0.25
                        }}
                    >
                        Filtros
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: 16,
                            fontWeight: 700,
                            color: "#212529",
                            lineHeight: 1.2
                        }}
                    >
                        Filtrar por estado
                    </Typography>
                </Box>
            </Box>

            {/* Contenido */}
            <CardContent sx={{ p: 3 }}>
                <Box>
                    <FieldLabel icon={InventoryIcon}>Estado del producto</FieldLabel>
                    <FormControl fullWidth>
                        <Select
                            id="filter-state"
                            value={valorSeleccionado}
                            onChange={handleChange}
                        >
                            {ProductStates.states.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </CardContent>
        </Card>
    );
};

export default FiltrosProductos;
